import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeam } from "core-integration/src/store/teams/types";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { CLUB_URLS } from "../utils/teams";
import Badge from "./Badge";

const BannerBackground = styled.div`
  background-color: transparent;
`;

const Banner = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: ${({ theme }) => theme.space[4]};
    max-width: 1220px;
    margin: auto;
    padding: ${({ theme }) => `${theme.space[2]} 0`};
  }
`;

const StyledBadge = styled(Badge)`
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.2);
  }
`;

const BadgeBanner = () => {
  const teamsById = useSelector(getTeamsById);
  const teams = Object.values(teamsById);
  const validTeams = teams.filter((team) => !team.unavailable);

  const trackingUrl =
    "?utm_source=Fantasy&utm_medium=Game&utm_campaign=Fantasy26";

  if (!teams) {
    return null;
  }

  return (
    <BannerBackground>
      <Banner>
        {validTeams.map((team: ITeam) => {
          const clubUrls = CLUB_URLS[team.code];
          if (!clubUrls) return null;

          return (
            <a
              key={team.code}
              href={`${clubUrls}${trackingUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              role="link"
            >
              <StyledBadge
                className="badgeHeader"
                team={team}
                isPresentation={false}
                sizes="30px"
              />
            </a>
          );
        })}
      </Banner>
    </BannerBackground>
  );
};

export default BadgeBanner;
